module.exports = __webpack_public_path__ + "img/enfj.9cace13f.png";